/**
 * Token 管理工具
 */

const TOKEN_KEY = 'auth_token';

/**
 * 保存 token
 */
export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

/**
 * 获取 token
 */
export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * 移除 token
 */
export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

/**
 * 检查是否有 token
 */
export function hasToken(): boolean {
  return !!getToken();
}



